/*
 * @Descripttion: 登录
 * @FilePath: /mall-wap-vue/src/api/login.js
 * @Author: 张兴业
 * @Date: 2020-09-24 15:13:26
 * @LastEditors: hl
 * @LastEditTime: 2026-06-16 19:36:49
 */
import request from "@/utils/request";
// 密码登录
export async function accountLogin(params) {
  const url = "/api/front/user/accountLogin";
  return request(url, {
    method: "POST",
    data: params
  });
}
// 手机验证码登录
export async function phoneLogin(params) {
  const url = "/api/front/user/phoneLogin";
  return request(url, {
    method: "POST",
    data: params
  });
}
// 发送验证码
export async function sendSms(params) {
  const url = "/api/front/user/sendSms";
  return request(url, {
    method: "POST",
    data: params
  });
}
// 微信登录
export async function wechatLogin(params) {
  const url = "/api/front/user/wechatLogin";
  return request(url, {
    method: "POST",
    data: params
  });
}
// 微信登录后绑定手机号
export async function phoneBinding(params) {
  const url = "/api/front/user/phoneBinding";
  return request(url, {
    method: "POST",
    data: params
  });
}

// 校验验证码
export async function checkVerifyCode(params) {
  const url = "/api/front/user/checkPhoneCode";
  return request(url, {
    method: "POST",
    data: params
  });
}

// 获取游客token
export async function getGuestToken(params) {
  const url = "/api/front/user/getGuestToken";
  return request(url, {
    method: "GET",
    data: params
  });
}
